module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_8003.cbd52597.png";